import { useQuery } from '@tanstack/react-query';
import { apiClient } from './client';
import type { PrivateDataResponse } from '@/types/api';

export interface PrivateDataParams {
  station: string;
  date: string;
}

export function usePrivateData(params: PrivateDataParams) {
  return useQuery({
    queryKey: ['private', 'data', params],
    queryFn: async () => {
      const res = await apiClient.get<PrivateDataResponse>('/private/data', {
        params: {
          station: params.station,
          date: params.date,
        },
      });
      return res.data;
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
    refetchOnWindowFocus: false,
    enabled: !!params.station && !!params.date,
  });
}
